import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
  useMediaQuery
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { appTheme } from '../../theme'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CrossIcon from '../../images/crossIcon2.svg'
import { ButtonCustom } from '../Button/ButtonCustom'
import {
  eventDetail,
} from '../../services/EventService'

export interface FooterProps {
  activePageTitle?: string
  canMoveNext?: boolean
  onSave?: () => Promise<void>
  nextClick?: any
  backClick?: any
  saveExit?: any
  showBackAndNextButton?: boolean
  disbledSave?: boolean
}

const FooterPropsValues = {
  showBackAndNextButton: true
}

const steps = [
  'Requesting Type',
  'Event Info',
  'Speakers & Staff',
  'Audience',
  'Date & Times',
  'Features & Requests',
  'Review & Submit'
]

// Custome CSS styles
const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    position: 'fixed',
    width: '100%',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1
  },
  dailogBox: {
    height: 'auto',
    width: '18rem',
    textAlign: 'center'
  }
})

var isWebView = true

export const Footer: React.FC<FooterProps> = props => {
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))

  const classes = useStyles()
  const navigate = useNavigate()
  const [canMoveBack, setCanMoveBack] = useState(false)
  const [activeStep, setActiveStep] = React.useState(
    steps.indexOf(props.activePageTitle as string)
  )
  


  const navigateOnHomePage = () => {
    navigate('/')
  }

  // Dialog Box
  const [open, setOpen] = React.useState(false)
  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'))

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  let { id } = useParams()
  const loadEventData = async () => {
    try {
      const { data } = await eventDetail(Number(id))
      if (data) {
        if (data.eventDetail.data !== null) {
          if (
            (data.eventDetail.data.seriesId === 1 && activeStep === 1) ||
            activeStep === 0
          ) {
            setCanMoveBack(true)
          } else {
            setCanMoveBack(false)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (id !== undefined && id !== null) {
      loadEventData()
    }
  }, [])

  // Dialog Box
  return (
    <div className={classes.root}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          background: 'white',
          pl: 10,
          pr: 5,
          pt: 1,
          boxShadow: '0px 7px 23px rgba(0, 0, 0, 0.2)'
        }}
      >
        {isWebView && activeStep !== 0 && (
          <ButtonCustom
            variant='outlined'
            borderColor='#333333'
            disabled={props.disbledSave}
            // onClick={props.saveExit}
            onClick={handleClickOpen}
            label={'Save and Exit'}
            icon={false}
          />
        )}

        <Box sx={{ flex: '1 1 auto' }} />

        {props.showBackAndNextButton && (
          <>
            <ButtonCustom
              backgroundColor='#ffffff'
              color='#333333'
              // disabled={activeStep === 0}
              disabled={canMoveBack}
              onClick={props.backClick}
              label='Back'
              icon={false}
            />

            <ButtonCustom
              icon={false}
              backgroundColor='#333333'
              color='#ffffff'
              disabled={props.canMoveNext === false}
              onClick={props.nextClick}
              label='Save and continue'
            />
          </>
        )}
      </Box>
      {/* Dialog Box */}
      <>
        {/* <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
          <DialogContent sx={{ margin: 'auto', mt: 4, mb: 2 }}>
            <DialogContentText
              color='primary'
              variant='h6'
              className={classes.dailogBox}
              lineHeight='20px'
            >
              Are you sure you want to exit the ETA Event Scheduler
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid container sx={{ align: 'center' }}>
              <Box width='100%' sx={{ mb: 1, mx: 6 }} style={flexItemCenter}>
                <Button
                  sx={{ mr: 4, textTransform: 'none' }}
                  onClick={handleClose}
                  style={{
                    backgroundColor: '#253D82',
                    color: '#ffffff',
                    height: '2.5rem',
                    width: '10.5rem',
                    borderRadius: '4rem'
                  }}
                >
                  {' '}
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                    Back
                  </Typography>
                </Button>
                <Button
                  sx={{ border: 2, textTransform: 'none' }}
                  variant='outlined'
                  onClick={navigateOnHomePage}
                  style={{
                    height: '2.5rem',
                    width: '10.5rem',
                    borderRadius: '4rem'
                  }}
                >
                  {' '}
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                    Yes, exit
                  </Typography>
                </Button>
              </Box>
              <Grid md={12} style={flexItemCenter} item>
                <Button
                  sx={{
                    textTransform: 'none',
                    mb: 2,
                    fontSize: '12',
                    fontWeight: 700,
                    color: '#006BD7'
                  }}
                  variant='text'
                  onClick={props.saveExit}
                >
                  Save and exit
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog> */}
        <Dialog
          open={open}
          onClose={handleClose}
          fullScreen={fullScreen}
          sx={{ '.MuiDialog-paper': { borderRadius: 3 } }}
        >
          {fullScreen && (
            <Box sx={{ width: { sm: 468 }, px: 3, pt: 4, pb: 1 }}>
              <IconButton
                onClick={handleClose}
                sx={{ width: '24px', height: '24px' }}
                style={{
                  float: 'right'
                }}
                size="large">
                <Box component='img' src={CrossIcon} alt='CrossIcon' />
              </IconButton>
            </Box>
          )}

          <Box
            paddingTop={fullScreen ? 1 : 4}
            sx={{ width: { sm: 468 }, px: 3, pb: 4 }}
          >
            <Box
              sx={{
                alignItems: 'flex-start',
                display: 'flex'
              }}
            >
              <Box
                sx={{
                  height: 'fit-content',
                  alignItems: 'center',
                  bgcolor: '#FFD74866',
                  borderRadius: 2,
                  display: 'flex',
                  justifyContent: 'center',
                  p: 1
                }}
              >
                <ErrorOutlineIcon sx={{ color: '#FB8C00', fontSize: 20 }} />
              </Box>

              <Box sx={{ ml: 2 }}>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 700,
                    letterSpacing: 0.1,
                    lineHeight: 1
                  }}
                >
                  Are you sure you want to exit the ETA Event Scheduler?
                </Typography>

                <Typography
                  sx={{
                    color: '#333',
                    letterSpacing: 0.1,
                    lineHeight: 1.4,
                    mt: 1
                  }}
                >
                  Your event request will be saved to your profile and
                  accessible on your dashboard.
                </Typography>
              </Box>
            </Box>

            <ButtonCustom
              icon={false}
              backgroundColor='#333'
              color='#fff'
              label={'Yes, save and exit'}
              disabled={false}
              onClick={props.saveExit}
              width='100%'
              sx={{
                height: 40,
                m: 0,
                mt: 2,
                textTransform: 'none'
              }}
            />

            <ButtonCustom
              variant='outlined'
              icon={false}
              label={'Exit without Saving'}
              onClick={navigateOnHomePage}
              width='100%'
              sx={{
                height: 40,
                borderColor: '#333',
                m: 0,
                mt: 2,
                textTransform: 'none'
              }}
            />
            <Button
              variant='text'
              sx={{ textTransform: 'none', mt: 2 }}
              onClick={handleClose}
              style={{
                color: '#333333',
                width: '100%'
              }}
            >
              {' '}
              <Typography sx={{ fontSize: 12, fontWeight: 700 }}>
                Cancel
              </Typography>
            </Button>
          </Box>
        </Dialog>
      </>
    </div>
  );
}

Footer.defaultProps = FooterPropsValues
